import { datasetFactory, componentFactory } from '@fusioncharts/core/src/lib';
import BoxAndWhiskerStatisticalCalc from '../dataset/boxandwhisker/box-and-whisker-statistical-calc';
/**
 * function to  create dataset
 * sort data wrt. x value
 * assign dataset to its parents
 **/
export default function (chart) {
  let datasetsJSON = chart.getFromEnv('dataSource').dataset,
    canvas = chart.getChildren('canvas')[0], // eslint-disable-line good-practices/no-single-usage-variable
    vCanvas,
    datasetParent = vCanvas = canvas.getChildren('vCanvas')[0],
    dsType = chart.config.defaultDatasetType || '',
    groupManager;

  if (!datasetsJSON) {
    chart.setChartMessage();
  }

  componentFactory(vCanvas, chart.getDSGroupdef(), 'datasetGroup_' + dsType);
  groupManager = vCanvas.getChildren('datasetGroup_' + dsType);
  groupManager && (datasetParent = groupManager[0]);

  componentFactory(chart, BoxAndWhiskerStatisticalCalc, 'BoxAndWhiskerStatisticalCalc');
  vCanvas.getChildren('datasetGroup_' + dsType)[0].addToEnv('BoxAndWhiskerStatisticalCalc',
    chart.getChildren('BoxAndWhiskerStatisticalCalc')[0]);

  // Adding the JSON data of line dataset to the parent of boxandwhisker ds
  datasetParent.addToEnv('lineJSON', chart._getLineJSONdata());
  datasetFactory(datasetParent, chart.getDSdef(), 'dataset', datasetsJSON.length, datasetsJSON);
}
